<template>
  <li class="list-none flex flex-col items-center justify-center min-w-fit">
    <Divider v-if="withDivider" />
    <div class="w-full text-center label-lg">
      <slot></slot>
    </div>
  </li>
</template>

<script>
import Divider from '@/Components/Divider'
export default {
  name: 'ListItemWithDivider',
  components: { Divider },
  props: {
    withDivider: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
}
</script>

<style></style>
